import {machine} from "../constants/machine.constants";
import scenarios from "./scenarios.json";
import {dataLoaderService} from "../services/dataLoaderService";
import {localStorageKeys as k} from "../index";

const i = machine.contextFields;

const initContext = {
    [i.data.currentNode]: [],
    [i.scenario.currentNode]: [],
    [i.data.currentIndex]: 0,
    [i.data.currentCardIndex]: 0,
    [i.scenario.currentIndex]: 0, // Back to 0
    [i.scenario.currentItem]: {},
    [i.sound.leftRepeats]: 0,
    [i.step.delay]: 1,
    [i.error.errorMessages]: "",
    [i.isScenarioCompleted]: false,
    [i.isCardsCompleted]: false,
    [i.isTextSynthesisPending]: false,
    [i.isCardPagination]: true,
    [i.langs.study]: "",
    [i.langs.base]: "",
    [i.langs.available]: [],
    availableVoices: []
}

const getScenarioById = (scenarios, id) => {
    let scenario = [];
    if (scenarios.length > 0) scenario = scenarios.find(item => item.id === id)?.actions || [];
    return scenario
}

const getPlayerScenarioInitData = async ({id, scenarioId}) => {
    const scenario = getScenarioById(scenarios, scenarioId);
    const lesson = await dataLoaderService.getLessonById(id);

    if (!lesson) return initContext;

    const langs = lesson.meta.langs;
    const studyLang = langs[0] || "";
    let baseLang = langs[1] || "";
    
    // If only 1 language exists, study and base will be the same
    if (langs.length === 1) {
        baseLang = langs[0];
    } else if (langs.length > 1 && studyLang === baseLang) {
        // Just in case they are the same in meta
        baseLang = langs[1];
    }

    const scenarioItemsWithId = (lesson.scenarioItems || []).map((item, index) => ({
        ...item,
        id: index
    }));

    const {
        data: {currentNode: fieldNameOfDataNode},
        scenario: {currentNode: fieldNameOfScenarioNode, currentItem: fieldNameOfCurrentItem},
        langs: {study: studyField, base: baseField, available: availableField}
    } = machine.contextFields

    const firstItem = scenario[0] || {};
    const newData = {
        lessonId: id, // Store current lesson ID
        scenarioId: scenarioId, // Store current scenario ID
        [fieldNameOfScenarioNode]: scenario,
        [fieldNameOfDataNode]: [{
            title: lesson.title,
            scenarioItems: scenarioItemsWithId,
            id: 0
        }],
        [fieldNameOfCurrentItem]: firstItem,
        [studyField]: studyLang,
        [baseField]: baseLang,
        [availableField]: langs,
        // Initialize session counters for the first item
        [i.sound.leftRepeats]: firstItem.props?.repeats || 0,
        [i.step.delay]: firstItem.props?.delay || 1
    }

    return {...initContext, ...newData}
}

export {initContext, getPlayerScenarioInitData}
